import $ from "jquery";
import * as Popper from "@popperjs/core";
import starRating from "./jquery.star-rating.js";

import "../css/app.scss";
import "bootstrap";

import "slick-slider/slick/slick.css";
import "slick-slider/slick/slick-theme.css";
import "toastify-js/src/toastify.css";
import "slick-slider";
import "lightgallery/css/lightgallery.css";
import StickySidebar from "sticky-sidebar";

window.Popper = Popper;
window.jQuery = window.$ = $;
$.fn.starRating = starRating;

import "./order";
import "./workshop";
import "./favorite";
import "./components";
import "./review";
import "./listFilter.js";
import "./dropdown.js";
import { cutTheText } from "./useful";

import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();

import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";

const isMobile = window.matchMedia("(max-width: 576px)").matches;

console.log(isMobile, "isMobile");

$(function () {
  // текущий путь + query (чтобы различать /watch?f=orders vs /watch?f=workshops)
  const current = window.location.pathname + window.location.search;

  // все ссылки и в десктоп-меню, и в mobile__header__content
  const $links = $('.header__navigation a[href]');

  // функция нормализации: убираем origin, приводим к виду path+search
  function normalizeHref(href) {
    try {
      const u = new URL(href, window.location.origin);
      return u.pathname + u.search;
    } catch (e) {
      return href || '';
    }
  }

  // сперва уберём активность
  $links.removeClass('is-active');

  // 1) пробуем точное совпадение path+search
  let $active = $links.filter(function () {
    return normalizeHref($(this).attr('href')) === current;
  });

  // 2) если точного нет — пробуем совпадение только по pathname (без query)
  if (!$active.length) {
    const currentPath = window.location.pathname;
    $active = $links.filter(function () {
      return normalizeHref($(this).attr('href')).split('?')[0] === currentPath;
    });
  }

  // 3) fallback: если ссылка — префикс текущего пути (актуально для разделов)
  if (!$active.length) {
    $active = $links.filter(function () {
      const linkPath = normalizeHref($(this).attr('href')).split('?')[0];
      return linkPath !== '/' && window.location.pathname.startsWith(linkPath);
    });
  }

  $active.addClass('is-active');
});

document.addEventListener("DOMContentLoaded", () => {
  const grid = document.querySelector(".tile-grid");
  if (!grid) return;

  if (!isMobile) {
    imagesLoaded(grid, () => {
      new Masonry(grid, {
        itemSelector: ".tile-item",
        columnWidth: ".tile-sizer",
        percentPosition: true,
        gutter: 16,
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (isMobile) {
    // Categories slider
    $(".categories__content").each((_, card) => {
      const $card = $(card);

      if (!$card.hasClass("slick-initialized")) {
        $card.slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 3.5,
          slidesToScroll: 1,
          arrows: true,
          nextArrow: `
        <svg class="slick-next-btn" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#FAFAFA" stroke="#E4E4E4"/>
          <path d="M17.7778 15.5554L22.2222 19.9999L17.7778 24.4443" stroke="#2E695D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `,
          prevArrow: `
        <svg class="slick-prev-btn" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#FAFAFA" stroke="#E4E4E4"/>
          <path d="M22.2222 24.4446L17.7778 20.0001L22.2222 15.5557" stroke="#2E695D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `,
        });
      }
    });

    // Examples Slider
    $(".tile-grid").each((_, card) => {
      const $card = $(card);

      // 🔥 чтобы slick точно не видел tile-sizer
      $card.children(".tile-sizer").remove();

      if (!$card.hasClass("slick-initialized")) {
        $card.slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 1.5,
          slidesToScroll: 1,
          arrows: true,
          nextArrow: `
        <svg class="slick-next-btn" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#FAFAFA" stroke="#E4E4E4"/>
          <path d="M17.7778 15.5554L22.2222 19.9999L17.7778 24.4443" stroke="#2E695D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `,
          prevArrow: `
        <svg class="slick-prev-btn" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#FAFAFA" stroke="#E4E4E4"/>
          <path d="M22.2222 24.4446L17.7778 20.0001L22.2222 15.5557" stroke="#2E695D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `,
        });
      }
    });
  }
  //Sticky sidebar

  if ($(".sidebar-container").length > 0) {
    new StickySidebar(".sidebar-container", {
      topSpacing: 80,
      bottomSpacing: 0,
      containerSelector: ".container",
      innerWrapperSelector: ".orders__filter",
    });
  }

  // Text Cut

  $(".need_cut")?.each((_, item) => {
    cutTheText(item, $(item).text());
  });

  // Star rating

  $(".rating").starRating({
    showInfo: false,
    starShape: "rounded",
  });

  //Для открытия всех блоков с role="link"
  $(document).on("click", '[role="link"][data-link]', function (e) {
    // Игнорируем клики по dropdown или по любым вложенным элементам с классом dropdown
    if (
      $(e.target).closest(".dropdown").length ||
      $(e.target).closest("a[data-fslightbox]").length ||
      $(e.target).closest(".item__info-buttons").length ||
      $(e.target).closest(".slick-arrow").length
    ) {
      e.stopPropagation();
      return;
    }

    const url = $(this).data("link");
    if (url) {
      window.open(url, "_blank");
    }
  });

  // Review Modal

  function resetReviewForm() {
    $("#review-modal form")[0].reset();
    $(".rating div > i").first().trigger("click");
  }

  $(".review__reset-form").on("click", resetReviewForm);

  function updateReusableCounter($field) {
    const $wrapper = $field.closest(".reusable");
    const $counter = $wrapper.find(".input__length");
    const $maxText = $field.attr("maxlength");

    const max = parseInt($maxText?.match(/\d+/)) || 0;
    let value = $field.val() || "";

    // Ограничиваем длину
    if (max && value.length > max) {
      value = value.slice(0, max);
      $field.val(value);
    }

    // Обновляем счётчик
    $counter.text(value.length);
  }

  // При вводе
  $(document).on("input", ".reusable input, .reusable textarea", function () {
    updateReusableCounter($(this));
  });

  // При первой загрузке страницы
  $(function () {
    $(".reusable input, .reusable textarea").each(function () {
      updateReusableCounter($(this));
    });
  });

  // Кнопка "Назад"
  $(document).on("click", ".back-button", function (e) {
    e.preventDefault();

    const fallback = $(this).data("fallback") || "/";

    // если есть предыдущая страница
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = fallback;
    }
  });
});
